module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "aboutBlissMall"
    }
  }, [_c('mt-header', {
    staticStyle: {
      "height": "50px"
    },
    attrs: {
      "title": "关于我们"
    }
  }, [_c('router-link', {
    attrs: {
      "slot": "left",
      "to": "/mine"
    },
    slot: "left"
  }, [_c('mt-button', [_c('img', {
    staticStyle: {
      "margin-left": "12px"
    },
    attrs: {
      "slot": "icon",
      "src": require("../../../assets/icon/back.png"),
      "height": "auto",
      "width": "8px"
    },
    slot: "icon"
  })])], 1)], 1), _vm._v(" "), _c('hr', {
    staticStyle: {
      "height": "1px",
      "background-color": "#d8d8d8"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    attrs: {
      "id": "aboutBlissMall-content-detail"
    }
  }, [_vm._v("\n         深圳市幸福商城科技股份有限公司 （以下简称幸福商城）2008年创立于深圳，凭借健康的食材和人性化的服务，幸福商城在各界普受好评。幸福商城微信公众号现今拥有百万粉丝，已成为国内知名O2O电商蛋糕品牌。集研发生产销售于一体，幸福商城始终坚持“百分百新鲜制作”，为消费者生产健康、安全、绿色的五星级烘焙食品。8年来，幸福商城以“用心、传递幸福”的企业使命不断超越自我，完善服务，给成千上万的粉丝带去幸福的味道。"), _c('br'), _vm._v("\n         自2015年8月以来，先后开发数十个一二线城市，包括深圳、上海、北京、广州、海口、武汉、广州等。用户可在微信服务号（幸福商城）下单，配送时长2-5小时，部分地区有1小时专车。\n  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "aboutBlissMall-footer"
    }
  }, [_c('div', {
    staticClass: "aboutBlissMall-foot-cell"
  }, [_c('img', {
    staticClass: "aboutBlissMall-cell-img",
    attrs: {
      "src": require("../../../assets/icon/map.png")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "aboutBlissMall-cell-title"
  }, [_vm._v("总部地址")]), _vm._v(" "), _c('span', {
    staticClass: "aboutBlissMall-cell-detail"
  }, [_vm._v("深圳市龙岗区布龙路339号鸿生源工业区A栋5层")])]), _vm._v(" "), _c('div', {
    staticClass: "aboutBlissMall-foot-cell"
  }, [_c('img', {
    staticClass: "aboutBlissMall-cell-img",
    attrs: {
      "src": require("../../../assets/icon/phone.png")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "aboutBlissMall-cell-title"
  }, [_vm._v("电话")]), _vm._v(" "), _c('span', {
    staticClass: "aboutBlissMall-cell-detail"
  }, [_vm._v("400-999-6666")])]), _vm._v(" "), _c('div', {
    staticClass: "aboutBlissMall-foot-cell"
  }, [_c('img', {
    staticClass: "aboutBlissMall-cell-img",
    attrs: {
      "src": require("../../../assets/icon/weibo.png")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "aboutBlissMall-cell-title"
  }, [_vm._v("微博")]), _vm._v(" "), _c('span', {
    staticClass: "aboutBlissMall-cell-detail"
  }, [_vm._v("幸福西饼BLISSCAKE")])]), _vm._v(" "), _c('div', {
    staticClass: "aboutBlissMall-foot-cell"
  }, [_c('img', {
    staticClass: "aboutBlissMall-cell-img",
    attrs: {
      "src": require("../../../assets/icon/weixin.png")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "aboutBlissMall-cell-title"
  }, [_vm._v("微信账号")]), _vm._v(" "), _c('span', {
    staticClass: "aboutBlissMall-cell-detail"
  }, [_vm._v("幸福西饼")])]), _vm._v(" "), _c('div', {
    staticClass: "aboutBlissMall-foot-cell"
  }, [_c('img', {
    staticClass: "aboutBlissMall-cell-img",
    attrs: {
      "src": require("../../../assets/icon/email.png")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "aboutBlissMall-cell-title"
  }, [_vm._v("投诉/建议邮箱")]), _vm._v(" "), _c('span', {
    staticClass: "aboutBlissMall-cell-detail"
  }, [_vm._v("ceo@blissmall.net")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c0812fb2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mine/aboutBlissMall/aboutBlissMall.vue
// module id = 592
// module chunks = 1